import { useEffect, useState } from 'react';
import { domainService } from '../services/domainService';
import type { Domain } from '../types/domain.types';

/**
 * Load a single domain by FQDN. Returns `null` for `data` once the lookup
 * completes if no matching domain is found (404 case).
 */
export function useDomain(name: string | undefined) {
  const [data, setData] = useState<Domain | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!name) {
      setIsLoading(false);
      return;
    }
    let cancelled = false;
    setIsLoading(true);
    setError(null);

    domainService
      .getByName(name)
      .then((d) => {
        if (!cancelled) setData(d);
      })
      .catch((err: unknown) => {
        if (!cancelled) setError(err instanceof Error ? err : new Error(String(err)));
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [name]);

  return { data, isLoading, error };
}
